<template>
    <div class="about-section" v-if="aboutArr != null" id="menu-link-about">
        <div class="container">
            <sectionTitle :options="[{ title : aboutArr.about_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: aboutArr.about_quote_img, title : aboutArr.about_quote_title, desc: aboutArr.about_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : aboutArr.about_desc_left, desc_right: aboutArr.about_desc_right}]"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: aboutArr.about_images_mobile}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <sectionImagesGrid :options="[{ cards: aboutArr.about_cards.slice(0, 3), grid_img : aboutArr.about_images[0].img}]" class="section-images-grid-about"></sectionImagesGrid>
            <sectionImagesMobile :options="[{ images: aboutArr.about_images_mobile_second}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <aboutImagesGrid :options="[{ cards: aboutArr.about_cards.slice(3), grid_img : aboutArr.about_images[1].img}]"></aboutImagesGrid>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import sectionImagesGrid from '@/components/partials/section-images-grid.vue'
    import aboutImagesGrid from '@/components/about/about-grid-images.vue'
    import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'about-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            aboutArr: 'loadAboutArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            sectionImagesGrid,
            aboutImagesGrid,
            sectionImagesMobile,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about/about-section.scss';
    @import '@/styles/components/about/respond/about-section-respond.scss';
</style>